
function useModalHelper(modal) {

    const onClose = (params= {duration: 300,idIconModal:null}) => {
        var {duration, idIconModal} = params
        duration = Number.isInteger(duration) ? duration : 300 
        const element = document.getElementById(modal.id);
        if (idIconModal != null){
            console.log(duration)
            const close_button = document.getElementById(idIconModal);
            close_button.classList.add("close_button_action")
        }
        if (element != null){
            element.classList.add('closing');
        }
        setTimeout(() => modal.remove(), duration);
        
    }
    

    return {onClose}
}

export default useModalHelper;